<template>
  <Form :errorMsg="errorMsg">
    <template v-slot:Title>
      Ajouter ou modifier une URL
    </template>

    <template v-slot:FormContent @submit="save">
      <FormRow>
        <label>Date</label>
        <BookmarkDate
          :creationDate="bookmark.importdate || bookmark.creationdate"
        ></BookmarkDate>
      </FormRow>

      <FormRow>
        <label for="uri">Uri</label>
        <input
          id="uri"
          type="text"
          v-model.trim="bookmark.uri"
        />
      </FormRow>
      <!-- <span>{{ bookmark.authenticationinfo }}</span>  faire afficher une popup de modification de l'objet auth-->

      <FormRow>
        <label for="description">Description</label>
        <textarea
          id="description"
          v-model.trim="bookmark.description"
        ></textarea>
      </FormRow>

      <FormRow>
        <label for="tags">Tags</label>
        <TagsInput id="tags" v-model="bookmark.tags"></TagsInput>
      </FormRow>
      <!-- <span>{{ bookmark.lang }}</span> -->
      <!-- <span>{{ bookmark.owner }}</span> si mon id n'est pas le meme alors c'est le bookmark d'un autre partage par un group -->

      <FormRow>
        <label for="private-alias">Private alias</label>
        <input
          id="private-alias"
          type="text"
          v-model.trim="bookmark.privatealias"
        />
      </FormRow>

      <FormRow>
        <label for="public-alias">Public alias</label>
        <input
          id="public-alias"
          type="text"
          v-model.trim="bookmark.publicalias"
        />
      </FormRow>

      <div class="actions">
        <Button class="button" v-on:click.prevent="cancel">Cancel</Button>
        <Button class="button" primary v-on:click.prevent="save">Save</Button>
      </div>
    </template>
  </Form>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Form from '@/components/common/Form'
import BookmarkDate from '@/components/common/BookmarkDate'
import Button from '@/components/common/Button.vue'
import FormRow from '@/components/common/FormRow'
import PageMainTitle from '@/components/common/PageMainTitle'
import TagsInput from '@/components/common/TagsInput'

@Component({
  name: 'BookmarkEdit',
  props: [
    'id',
    'uri',
    'description',
    'tags',
    'privatealias',
    'publicalias',
    'lang'
  ],
  components: {
    BookmarkDate,
    Button,
    Form,
    FormRow,
    PageMainTitle,
    TagsInput
  }
})
class BookmarkEdit extends Vue {
  @Prop id
  @Prop uri
  @Prop description
  @Prop tags
  @Prop privatealias
  @Prop publicalias
  @Prop lang

  errorMsg = ''
  bookmark = {
    uri: this.uri,
    creationdate: new Date(),
    description: this.description,
    tags: this.stringToArray(this.tags),
    privatealias: this.stringToArray(this.privatealias),
    publicalias: this.stringToArray(this.publicalias),
    lang: this.lang
  }

  fetchBookmark() {
    if (this.id !== 'new') {
      this.$fetch.get(`/bookmarks/${this.id}`).then(
        data => {
          this.bookmark = data
        },
        err => {
          this.errorMsg = err.cause
        }
      )
    } else if (this.bookmark.uri) {
      let searchParams = new URLSearchParams()
      this.uri && searchParams.append('uri', this.bookmark.uri)
      this.$fetch.get(`/bookmarks?${searchParams.toString()}`).then(
        data => {
          if (data && data.info.total > 0) {
            let b = data.result[0]
            b.description = b.description + '\n' + new Date().toISOString().slice(0, 10) + '\n' + this.bookmark.description
            b.tags = [...new Set(this.stringToArray(b.tags).concat(this.bookmark.tags))]
            b.privatealias = [...new Set(this.stringToArray(b.privatealias).concat(this.bookmark.privatealias))]
            b.publicalias = [...new Set(this.stringToArray(b.publicalias).concat(this.bookmark.publicalias))]
            b.lang = b.lang || this.bookmark.lang

            this.bookmark = b
          }
        },
        err => {
          this.errorMsg = err.cause
        }
      )
    }
  }

  cancel() {
    this.$router.go(-1)
  }

  stringToArray(s) {
    if (!s) {
      return []
    }
    
    if (!Array.isArray(s)) {
      return s.split(/[,\s*]/)
    }

    return s
  }

  save() {
    let promise
    if (!this.bookmark.tags) {
      this.bookmark.tags = []
    } else if (!Array.isArray(this.bookmark.tags)) {
      this.bookmark.tags = this.bookmark.tags.split(/[,\s*]/)
    }
    if (!this.bookmark.privatealias) {
      this.bookmark.privatealias = []  
    } else if (!Array.isArray(this.bookmark.privatealias)) {
      this.bookmark.privatealias = this.bookmark.privatealias.split(/[,\s*]/)
    }
    if (!this.bookmark.publicalias) {
      this.bookmark.publicalias = []
    } else if (!Array.isArray(this.bookmark.publicalias)) {
      this.bookmark.publicalias = this.bookmark.publicalias.split(/[,\s*]/)
    }

    if (this.bookmark.id) {
      promise = this.$fetch.put(`/bookmarks/${this.bookmark.id}`, this.bookmark)
    } else {
      promise = this.$fetch.post(`/bookmarks`, this.bookmark)
    }

    promise.then(
      data => {
        console.log('ok')
        let query = {}
        query.id = this.bookmark.id || data.id
        this.$router.push({ name: 'Home', query })
      },
      err => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }

  beforeMount() {
    console.log('beforeMounted edit')
    this.fetchBookmark()
  }
}

export default BookmarkEdit
</script>

<style lang="less" scoped>
.actions {
  display: flex;
  justify-content: space-around;
  margin-top: var(--margin--small);
  padding: var(--margin--medium) var(--margin--small);

  border-top: 5px solid var(--color-white--darker);
}
</style>